<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3">
            <smallBar :user="user"></smallBar>
          </div>
          <div class="col-md-9">
            <div class="widget-wrap">
              <div class="widget-header block-header margin-bottom-0 clearfix">
                <div class="pull-left">
                  <h3>交易階段</h3>
                </div>
                <button class="pull-right btn btn-info" @click="AddStageModal = true" style="padding: 5px 60px"><i class="fa fa-plus"></i> 新增階段</button>
              </div>
              <div class="widget-container">
                <p class="alert alert-info">可在此區自訂所有交易的階段，也可拖曳改變順序，或是新增您所需要的階段</p>
                <div class="widget-content">
                  <div>
                    <draggable class="list-group setting-ul" element="ul" v-model="stages" :options="dragOptions" @change="onChange()">
                      <transition-group type="transition">
                        <li class="list-group-item stage_box" v-for="stage in stages" :key="stage.stage_no" @click="EditStage(stage)" v-bind:style="stage_width">
                          <i class="fa fa-pen"></i> 階段{{stage.stage_no + 1}}<br>
                          {{stage.name}}
                        </li>
                      </transition-group>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
    <!-- modal template start-->
    <div v-if="AddStageModal" @keyup.esc="AddStageModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="AddStageModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                新增交易階段
              </div>
              <a class="btn-close" @click="AddStageModal = false">
                  <i class="zmdi zmdi-close"></i>
                </a>
            </div>
            <div class="modal-body">
              <div name="body">
                <div class="input login-input">
                  <input class="form-control login-frm-input" name="new_stage_name" type="text" placeholder="階段名稱" v-model="new_stage_name" v-validate="'required'">
                  <i v-show="errors.has('new_stage_name')" class="fa fa-warning"></i>
                  <span v-show="errors.has('new_stage_name')" class="help is-danger">不可為空值
                      </span>
                  <!-- <input class="form-control login-frm-input" type="text" placeholder="階段描述" v-model="new_stage_description"> -->
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="validateBeforeSubmit">
                  新增
                </button>
                <button class="btn btn-primary" @click="AddStageModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="EditStageModal" @keyup.esc="EditStageModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="EditStageModal = false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                修改交易階段
              </div>
              <a class="btn-close" @click="EditStageModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body">
              <div name="body">
                <div class="input login-input">
                  <input class="form-control login-frm-input" type="text" placeholder="階段名稱" v-model="new_stage_name">
                  <!-- <input class="form-control login-frm-input" type="text" placeholder="階段描述" v-model="new_stage_description"> -->
                </div>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-primary" @click="UpdateStage">
                  更新
                </button>
                <button class="btn btn-primary" @click="EditStageModal = false">
                  取消
                </button>
                <button class="btn btn-fail" @click="DeleteStage">
                  刪除
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import smallBar from './SmallBar.vue';
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'

export default {
  name: 'hello',
  components: {
    draggable,smallBar
  },
  data() {
    return {
      stages: [],
      AddStageModal: false,
      EditStageModal: false,
      new_stage_name: '',
      will_changed_stage: '',
      stage_width: ''
    }
  },
  created() {
    this.getSetting();
  },
  props: ['toggle_aside','user'],
  computed: {
    dragOptions() {

    },
  },
  methods: {
    onChange(){
      this.stages.forEach(function(stage, index) {
        stage.stage_no = index
      });
      // update stage sort
      const vm = this;

      this.axios.put('settings/update_stage_sort', {
        setting: { 'stages': vm.stages }
      })
      .then(function(response) {
        if (response.status == 200) {
        } else {
          // TODO: show alert
          console.log('Update Stage Failed')
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
      
    },
    getSetting() {
      // defiine vm to assign this (assign vue data) because in axios there is other this
      const vm = this;
      this.axios.get('settings/get_stage').then(
        function(response) {
          if (response.status == 200 && response['data']['data']) {
            vm.stages = response['data']['data']['stages']
            var stage_len = vm.stages.length
            // auto calculate draggable view width
            vm.stage_width = {
              'width': 100 / stage_len + '%'
            }
          } else {
            console.log('Error')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.AddStage();
        } else {
          console.log('fails')
        }
      });
    },
    AddStage() {
      var stage_count = this.stages.length
      this.stages.push({
        "name": this.new_stage_name,
        "stage_no": stage_count,
        "tag": ''
      })
      this.AddStageModal = false
      const vm = this;
      this.axios.post('settings/add_stage', {
        setting: {
          name: vm.new_stage_name,
          stage_no: stage_count,
        }
      })
      .then(
        function(response) {
          if (response.status == 200) {
            $('.stage_box').css('width',(100/$('.stage_box').length)+"%")
            // update created stage's tag value
            vm.stages[vm.stages.length-1].tag = response['data']['data']['stage_tag']
          } else {
            // TODO: show alert
            console.log('Add Stage Failed')
          }
        }).catch(function(error) {
        console.log('error:', error)
      });
    },
    EditStage(stage) {
      this.will_changed_stage = stage
      this.EditStageModal = true
      this.new_stage_name = stage.name
    },
    UpdateStage() {
      this.will_changed_stage.name = this.new_stage_name
      this.EditStageModal = false
      const vm = this;
      this.axios.put('settings/update_stage_info', {
          setting: vm.will_changed_stage
        })
        .then(function(response) {
          if (response.status == 200) {
            $('.stage_box').css('width',(100/$('.stage_box').length)+"%")
          } else {
            // TODO: show alert
            console.log('Update Stage Failed')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    DeleteStage() {
      // delete in html
      var index = this.will_changed_stage.stage_no
      // delete stage
      const vm = this;
      this.axios.delete('settings/delete_stage', {
          params: {
            setting: vm.will_changed_stage
          }
        })
        .then(function(response) {
          if (response.status == 200) {
            vm.stages.splice(parseInt(index), 1)
            vm.EditStageModal = false
            $('.stage_box').css('width',(100/$('.stage_box').length)+"%")
          } else {
            // TODO: show alert
            console.log('Delete Stage Failed')
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
  },
}
</script>




// WEBPACK FOOTER //
// SetStages.vue?f67767d2